var render = function render(){var _vm=this,_c=_vm._self._c;return _c('submit-documents-modal',{attrs:{"active":_vm.active,"quote-id":_vm.quoteId,"title":"Submit Documents","subtitle":"Select documents to submit","is-audanet":true,"submit-disabled":_vm.isSubmitting},on:{"submit":_vm.onSubmit,"cancel":_vm.cancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }